/**
 * A lil utility for copying a string to the clipboard.
 *
 * @param {string} str - The string to copy to the clipboard.
 * @return {boolean} Whether the string was successfully copied.
 */
export default function copyToClipboard(str: string) {
  // browser context only, plz.
  if (!document) {
    return false;
  }

  // We need to create a temporary input element in order to copy it's value
  // to the clipboard. It's ugly af, but there's no avoiding it.
  const input = document.createElement('input');
  input.setAttribute('style', 'position: absolute; left: -2000px');
  input.setAttribute('value', str);
  document.body.appendChild(input);

  // iOS devices require some extra steps
  if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
    // @ts-ignore
    input.contentEditable = true;
    input.readOnly = false;
    const range = document.createRange();
    range.selectNodeContents(input);
    const selection = window.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
    input.setSelectionRange(0, 999999);
  } else {
    input.select();
  }

  try {
    document.execCommand('copy');
    document.body.removeChild(input);
    return true;
  } catch (e) {
    document.body.removeChild(input);
    return false;
  }
}
